module.exports = __webpack_public_path__ + "static/media/idolatress-no-1.f7df8ae7.jpg";